import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Website.css';
import icon from './assets/logo_clear.png';

const chromeStoreUrl = 'https://chromewebstore.google.com/detail/unsubscriber-mass-unsubsc/jpaajppadbkogfmgofandmiglolmecea';

const navItems = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/contact', label: 'Contact' },
];

export default function Navbar() {
  return (
    <header className="site-header">
      <nav className="site-nav" aria-label="Primary">
        <Link className="brand-link" to="/">
          <img src={icon} alt="" />
          <span>Mass Unsubscriber</span>
        </Link>
        <div className="nav-links">
          <a href="/#pricing">Pricing</a>
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </div>
        <a className="nav-cta" href={chromeStoreUrl} target="_blank" rel="noreferrer">Get Extension</a>
      </nav>
    </header>
  );
}
